import { Button, Modal } from 'antd';
import { t } from 'i18next';
import parse from 'html-react-parser';
import IconSuccess from '../../../assets/Images/icons/icon-success';

const ModalConfirm = ({
    open,
    title = t('common.ConfirmProcess'),
    text = 'Lorem ipsum dolor sit amet',
    handelClose,
    handelOk,
    loading,
    width = 135,
    isConfirm = true,
    icon = <IconSuccess />,
    confirmText = null,
    cancelText = null,
}) => {
    return (
        <Modal
            width={455}
            className="_modal"
            footer={false}
            open={open}
            onCancel={handelClose}
        >
            <div className="flex flex-col space-y-4 justify-center items-center py-6 text-center">
                {icon}
                <div className="text-2xl font-semibold whitespace-pre-line">
                    {title}
                </div>
                <div className={`whitespace-pre-line text-[#65707A]`}>
                    {parse(text)}
                </div>
            </div>
            <div className="flex justify-center items-center space-x-4">
                {isConfirm ? (
                    <>
                        <Button
                            style={{ width }}
                            type="primary"
                            onClick={handelClose}
                            size="large"
                            ghost
                            className="w-36"
                        >
                            {cancelText ? cancelText : t('common.Cancel')}
                        </Button>

                        <Button
                            style={{ width }}
                            loading={loading}
                            onClick={handelOk}
                            size="large"
                            type="primary"
                            className="w-36"
                        >
                            {confirmText ? confirmText : t('common.Confirm')}
                        </Button>
                    </>
                ) : (
                    <Button
                        onClick={handelOk}
                        className="w-36"
                        size="large"
                        type="primary"
                    >
                        {t('common.OK')}
                    </Button>
                )}
            </div>
        </Modal>
    );
};
export default ModalConfirm;
